<template>
  <div>
    <div v-if="CvcqlBuilderIds.hasChildren(operatorKey)" class="pa-4 pr-0" style="border: solid darkgray 1px">
      <span class="font-weight-medium" style="text-decoration: underline">
        <v-select :disabled="readonly"
          class="d-inline-block select-field-no-child-input" required dense hide-details hide-selected
          append-icon="" text="text" value="value" height="14px"
          v-model="operatorKey"
          :items="logicalOperators"
          @change="onQueryChange">
          <template v-slot:selection="{ item }">
            <div class="black--text">
              {{item.text}}
            </div>
          </template>
        </v-select>
      </span> THE FOLLOWING:

      <v-icon color="dark-grey" class="float-right mr-4 cursor-pointer"
              v-if="!readonly && removeButtonClicked" @click="removeClicked">
        mdi-trash-can
      </v-icon>

      <v-container fluid class="pa-0" :class="{'pl-10': !readonly}">
        <transition-group name="list-complete" tag="p" class="ma-0">
          <v-row v-for="(item, i) in operatorValue" :key="'operator-' + operatorId + i.toString()" class="list-complete-item ma-0 mt-2">
            <v-col
                class="pb-0 font-weight-medium" style="text-decoration: underline;"
                :class="{'mt-4': !readonly && CvcqlBuilderIds.hasChildren(Object.keys(item)[0])}"
                :style="{'max-width': readonly ? '' : '100px', 'text-decoration': readonly ? '' : 'underline', 'min-width': readonly ? '100%' : ''}">

              <v-select v-if="i > 0" :disabled="readonly"
                class="d-inline-block select-field-no-child-input" required dense hide-details hide-selected
                append-icon="" text="text" value="value" height="14px" style="min-width: 36px;"
                v-model="operatorNot[i]"
                :items="childrenNotItems"
                @change="onQueryChange">
                <template v-slot:selection="{ item }">
                  <div class="black--text">
                    {{item.text}}
                  </div>
                </template>
              </v-select>

            </v-col>
            <v-col class="pb-0">
              <query-builder-operator
                ref="childrenOperators"
                :initial-query="item"
                :add-button-clicked="addButtonClicked"
                :remove-button-clicked="removeOperator"
                :on-query-change="onQueryChange"
                :readonly="readonly"/>
            </v-col>
          </v-row>
        </transition-group>

        <v-row v-if="!readonly" class="ma-0 mt-6">
          <v-col class="pb-0 font-weight-medium" style="max-width: 100px;">
            <div v-if="operatorValue.length > 0">
              {{operatorKey === CvcqlBuilderIds.and ? 'AND' : 'OR'}}
            </div>
          </v-col>
          <v-col class="pb-0 pt-2">
            <v-btn v-on:click="addClicked" ref="addButton" class="cvc-button">+ Add Condition</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div v-else>
      <div v-if="!readonly" style="position: absolute; transform: translate(-145px, 0)">
        {{operatorId.substring('condition-'.length).toUpperCase()}}
      </div>
      <span>
        <v-select v-if="!readonly"
          class="d-inline-block select-field-no-child-input mx-2" required dense hide-details hide-selected
          append-icon="" text="text" value="value" height="14px" style="min-width: 36px;"
          v-model="operatorNot"
          :items="selfNotItems"
          @change="onQueryChange"/>
        <span v-else>{{selfNotItems.find(i => i.value === operatorNot).text}} </span>

        <v-select v-if="!readonly"
          class="d-inline-block select-field-no-child-input mx-2" required dense hide-details hide-selected
          append-icon="" text="text" value="value" height="14px" style="min-width: 36px;"
          v-model="operatorKey"
          :items="conditionOperators"
          @change="onQueryChange"/>
        <span v-else>{{conditionOperators.find(i => i.value === operatorKey).text}} </span>

        <belongs-to v-if="operatorKey === 'belongs_to'" ref="operator" class="fade-in"
          :initial-config="operatorValue"  :on-query-change="onQueryChange" :readonly="readonly"/>
        <acorn-code v-if="operatorKey === 'acorn_code'" ref="operator" class="fade-in"
          :initial-config="operatorValue" :on-query-change="onQueryChange" :readonly="readonly"/>
        <has-visited v-if="operatorKey === 'has_visited'" ref="operator" class="fade-in"
          :initial-config="operatorValue"  :on-query-change="onQueryChange" :readonly="readonly"/>
        <lives-in v-if="operatorKey === 'lives_in'" ref="operator" class="fade-in"
          :initial-config="operatorValue" :on-query-change="onQueryChange" :readonly="readonly"/>
        <time-spent-listening v-if="operatorKey === 'time_spent_consuming'" ref="operator" class="fade-in"
          :initial-config="operatorValue" :on-query-change="onQueryChange" :readonly="readonly"/>
        <subscription v-if="operatorKey === 'subscription'" ref="operator" class="fade-in"
          :initial-config="operatorValue" :on-query-change="onQueryChange" :readonly="readonly"/>
        <v-icon color="red" style="transform: translate(20px, -2px)" class="cursor-pointer"
                v-if="!readonly && removeButtonClicked" @click="removeClicked">
          mdi-close
        </v-icon>
      </span>
    </div>
  </div>
</template>

<script>
import CvcqlBuilderIds from '@/helpers/CvcqlBuilderIds';
import AcornCode from "@/components/ProfileBuilder/Operators/AcornCode";
import LivesIn from "@/components/ProfileBuilder/Operators/LivesIn";
import BelongsTo from "@/components/ProfileBuilder/Operators/BelongsTo";
import HasVisited from "@/components/ProfileBuilder/Operators/HasVisited";
import TimeSpentListening from "@/components/ProfileBuilder/Operators/TimeSpentListening";
import Subscription from "@/components/ProfileBuilder/Operators/Subscription";

export default {
  name: "QueryBuilderOperator",
  components: {Subscription, TimeSpentListening, HasVisited, AcornCode, BelongsTo, LivesIn},
  props: {
    initialQuery: {
      type: Object,
      required: true,
    },
    addButtonClicked: {
      type: Function,
      required: true,
    },
    removeButtonClicked: {
      validator: prop => typeof prop === 'function' || prop === null,
      required: true,
    },
    onQueryChange: {
      type: Function,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      operatorId: null,
      operatorKey: null,
      operatorValue: null,
      operatorNot: null,  // Can be true, false or an array of true, false for children operators.
      CvcqlBuilderIds: CvcqlBuilderIds,
      logicalOperators: [
        {text: 'ANY OF', value: CvcqlBuilderIds.or},
        {text: 'ALL OF', value: CvcqlBuilderIds.and},
      ],
      conditionOperators: [
        {text: '...', value: 'condition'},
        {text: 'belong to existing segment', value: 'belongs_to'},
        {text: 'have an acorn code', value: 'acorn_code'},
        {text: 'have ever visited', value: 'has_visited'},
        {text: 'listen', value: 'time_spent_consuming'},
        {text: 'live in', value: 'lives_in'},
        {text: 'subscribe under', value: 'subscription'},
      ]
    }
  },
  computed: {
    childrenNotItems() {
      return [
        {text: this.operatorKey === CvcqlBuilderIds.and ? 'AND' : 'OR', value: false},
        {text: this.operatorKey === CvcqlBuilderIds.and ? 'AND NOT' : 'OR NOT', value: true},
      ]
    },
    selfNotItems() {
      return [
        {text: 'Users that', value: false},
        {text: 'Users that do not', value: true},
      ]
    }
  },
  created() {
    this.onChangeInitial();
  },
  destroyed() {
    if (CvcqlBuilderIds.hasChildren(this.operatorKey)) {
      CvcqlBuilderIds.resetLogicId(this.operatorId.substring('condition-'.length));
    } else {
      CvcqlBuilderIds.resetConditionId(this.operatorId.substring('condition-'.length));
    }
  },
  methods: {
    onChangeInitial() {
      this.operatorKey = Object.keys(this.initialQuery)[0];
      this.operatorValue = Object.values(this.initialQuery)[0];
      if (CvcqlBuilderIds.hasChildren(this.operatorKey)) {
        this.operatorValue = [...this.operatorValue]

        if (!this.operatorId) this.operatorId = CvcqlBuilderIds.popLogicId();
        this.getOperatorNotForChildren();
      } else {
        this.operatorValue = {...this.operatorValue}

        if (!this.operatorId) this.operatorId = CvcqlBuilderIds.popConditionId();
        this.getOperatorNotForSelf();
      }
    },
    getOperatorNotForChildren() {
      this.operatorNot = [];
      let childOperatorKey;
      let childOperatorValue;
      let childOperatorNot;

      // We do not support 'AND NOT' or 'OR NOT' on the first child.
      // Instead pass it to the child operator's component
      if (this.operatorValue.length > 0) this.operatorNot = this.operatorNot.concat(false);

      for (let i = 1; i < this.operatorValue.length; i++) {
        childOperatorKey = Object.keys(this.operatorValue[i])[0];
        childOperatorValue = Object.values(this.operatorValue[i])[0];
        childOperatorNot = false;

        while (childOperatorKey === CvcqlBuilderIds.not) {
          childOperatorKey = Object.keys(childOperatorValue)[0];
          childOperatorValue = Object.values(childOperatorValue)[0];
          childOperatorNot = !childOperatorNot;
        }

        this.operatorValue[i] = {[childOperatorKey]: childOperatorValue}
        this.operatorNot = this.operatorNot.concat(childOperatorNot);
      }
    },
    getOperatorNotForSelf() {
      this.operatorNot = false;
      while (this.operatorKey === CvcqlBuilderIds.not) {
        this.operatorKey = Object.keys(this.operatorValue)[0];
        this.operatorValue = Object.values(this.operatorValue)[0];
        this.operatorNot = !this.operatorNot;
      }
    },

    // Operators with children specific. Can assume operatorValue and operatorNot are arrays.
    addClicked() {
      this.addButtonClicked(this.$refs.addButton.$el, this.addOperator)
    },
    addOperator(operator) {
      this.operatorNot = this.operatorNot.concat(false);
      this.operatorValue = this.operatorValue.concat(operator);
      this.onQueryChange();
    },
    removeClicked() {
      this.removeButtonClicked(this.initialQuery)
    },
    removeOperator(operator) {
      const index = this.operatorValue.indexOf(operator);
      if (index >= 0) {
        this.operatorNot = this.operatorNot.filter((o, i) => i !== index);
        this.operatorValue = this.operatorValue.filter((o, i) => i !== index);
        this.onQueryChange();
      }
    },

    getQuery() {
      if (CvcqlBuilderIds.hasChildren(this.operatorKey)) {
        let childQuery;
        const childQueries = (this.$refs.childrenOperators || []).map((r, i) => {
          childQuery = r.getQuery();
          if (this.operatorNot[i]) childQuery = {[CvcqlBuilderIds.not]: childQuery}
          return childQuery;
        });

        return {[this.operatorKey]: childQueries}
      } else {
        let query = {
          [this.operatorKey]: this.$refs.operator ? this.$refs.operator.getQuery() : {}
        };
        if (this.operatorNot) query = {[CvcqlBuilderIds.not]: query}

        return query
      }
    },
    getLogicText() {
      if (CvcqlBuilderIds.hasChildren(this.operatorKey)) {
        const childLogicTexts = (this.$refs.childrenOperators || []).map((r) => {
          return r.getLogicText()
        }).filter(t => t !== null);

        if (childLogicTexts.length === 0) {
          return null;
        } else if (childLogicTexts.length === 1) {
          return childLogicTexts[0]
        } else {
          return "( " + childLogicTexts.join(` ${this.operatorKey} `) + " )"
        }
      } else {
        return this.operatorId.substring('condition-'.length).toUpperCase();
      }
    }
  },
  watch: {
    initialQuery() {
      this.onChangeInitial();
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins";

  .list-complete-enter-active {
    transition: all 1s;
  }
  .list-complete-enter
  /* .list-complete-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateX(30px);
  }
  .list-complete-leave-active {
    position: absolute;
  }
</style>